module.exports = __webpack_public_path__ + "media/icons/card-1-3827aaed.png";